import { FC, forwardRef, useMemo } from "react";
import { TextField } from "@mui/material";
import { InputProps as StandardInputProps } from "@mui/material/Input/Input";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { FilterTriggerComponentProps } from "@/components/common/select/dropdown-select/utils/types/filterTriggerComponentProps";
import { InfrastructureArchitectureSelectTriggerInputComponent } from "@/components/pages/infrastructure-architecture/components/select-panel/body/common/InfrastructureArchitectureSelectTriggerInputComponent";

export const InfrastructureArchitectureSelectTriggerComponent: FC<
  FilterTriggerComponentProps
> = (props) => {
  const { selectedValues, onClick, open, label } = props;

  const InputComponent: StandardInputProps["inputComponent"] = useMemo(() => {
    if (!props.selectedValues.length) {
      return;
    }

    return forwardRef(() => (
      <InfrastructureArchitectureSelectTriggerInputComponent {...props} />
    ));
  }, [props]);

  const error =
    props.error && typeof props.error === "string" ? props.error : undefined;

  return (
    <TextField
      fullWidth
      label={label}
      size="small"
      focused={false}
      error={!!props.error}
      helperText={error}
      onClick={onClick}
      disabled={props.disabled}
      InputLabelProps={{ shrink: !!selectedValues.length || open }}
      InputProps={{
        inputComponent: InputComponent,
        endAdornment: open ? (
          <ArrowDropUpIcon fontSize="small" sx={{ color: "action" }} />
        ) : (
          <ArrowDropDownIcon fontSize="small" sx={{ color: "action" }} />
        ),
        sx: { pr: 1, cursor: "pointer" },
        inputProps: { sx: { cursor: "pointer" } },
      }}
    />
  );
};
